import { getEntryTimestamps } from "./getEntryTimestamps.mjs";
function configureEntryTimestampsGetter(opts) {
  const { gcinstant, replicantClientPromise, getPlatformStorage } = opts;
  let replicant = void 0;
  void replicantClientPromise.then((replicantClient) => {
    var _a;
    if (!((_a = replicantClient.asyncGetters) == null ? void 0 : _a.getEntryTimestamps)) {
      console.error(
        "Replicant async getter `getEntryTimestamps` is undefined. Extend Replicant configuration with `extendReplicantConfigForAnalytics`."
      );
      return;
    }
    replicant = replicantClient;
  });
  gcinstant.setEntryTimestampsGetter(async (playerIds) => {
    if (!replicant) {
      return {};
    }
    const states = replicant.friends.getFriendsStates();
    if (playerIds.every((id) => states[id])) {
      return Promise.resolve(
        getEntryTimestamps(playerIds, (id) => {
          var _a;
          const state = states[id].state;
          if (!getPlatformStorage) {
            return (_a = state.gcinstant) == null ? void 0 : _a.platformStorage;
          }
          return getPlatformStorage(state);
        })
      );
    }
    if (typeof replicant.asyncGetters.getEntryTimestamps !== "function") {
      throw Error("asyncGetters.getEntryTimestamps is not a function");
    }
    return replicant.asyncGetters.getEntryTimestamps(playerIds);
  });
}
export {
  configureEntryTimestampsGetter
};
